module.exports = __webpack_public_path__ + "static/img/brees-2006-slide-3.49b44ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-slide-3.jpg
// module id = bMPv
// module chunks = 1